<template lang="pug">
	#app
		book-layout
			vue-page-transition(name="fade")
				router-view
</template>

<script>
import BookLayout from '@/layouts/BookLayout'

export default {
	name      : 'App',
	components: {
		BookLayout
	}
}
</script>
